import { render, staticRenderFns } from "./RetrievePasswordPhone.vue?vue&type=template&id=2a25583c&scoped=true"
import script from "./RetrievePasswordPhone.vue?vue&type=script&lang=js"
export * from "./RetrievePasswordPhone.vue?vue&type=script&lang=js"
import style0 from "./RetrievePasswordPhone.vue?vue&type=style&index=0&id=2a25583c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25583c",
  null
  
)

export default component.exports